import type {JoyIconsId} from '@maltjoy/icons';
import type {ProfileSuggestionType} from '@api';

export type SuggestionConfig = {icon: JoyIconsId; title: string; subtitle: string; cta: string; dismissable: boolean};

export const suggestionConfigKeys = [
    'MALT_PROJECT',
    'RECENT_EXPERIENCE',
    'ONGOING_EXPERIENCE',
    'PORTFOLIO',
    'RECOMMENDATION',
    'CUSTOM_CATEGORY',
] as const satisfies ProfileSuggestionType[];

export type SuggestionConfigKey = (typeof suggestionConfigKeys)[number];
